import React, { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";
import MaintenancePage from "@/pages/MaintenancePage";

// Site-wide on/off gate. Fetches the maintenance flag and, when ON, shows the
// branded maintenance screen for EVERYONE (public, customer, admin) across all routes.
// Polls periodically so the site auto-restores shortly after it's turned back on.
export default function SiteGate({ children }) {
  const [maintenance, setMaintenance] = useState(null); // null = loading

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/site/status");
      setMaintenance(Boolean(data.maintenance));
    } catch {
      // On error, fail OPEN (treat as live) so a transient blip never hides a working site.
      setMaintenance((prev) => (prev === null ? false : prev));
    }
  }, []);

  useEffect(() => {
    check();
    const id = setInterval(check, 15000);
    return () => clearInterval(id);
  }, [check]);

  if (maintenance === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0B0F17]">
        <Loader2 className="h-8 w-8 animate-spin text-orange-500" />
      </div>
    );
  }

  if (maintenance) return <MaintenancePage />;
  return children;
}
